// extracted by css-extract-rspack-plugin
export default {"button":"ZEoLmLWjIcVyPKpb","small":"JZ4yizqcIZwDiQzj","body":"EzCOQVVUt104uxcx"};